var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 94.7225C21.8844 94.7225 0.638672 73.4767 0.638672 47.3612C0.638672 21.2457 21.8844 0 47.9999 0C56.8467 0 65.4759 2.45522 72.956 7.10134C74.2633 7.91256 74.6639 9.63042 73.8527 10.9379C73.0401 12.2452 71.3222 12.6487 70.0162 11.8346C63.4198 7.73683 55.8064 5.57207 47.9999 5.57207C24.9571 5.57207 6.21053 24.3192 6.21053 47.3614C6.21053 70.4037 24.9571 89.1506 47.9999 89.1506C71.0421 89.1506 89.7893 70.4034 89.7893 47.3612C89.7893 42.7296 89.0376 38.1821 87.5548 33.8451C87.0571 32.3897 87.8349 30.8052 89.2903 30.3075C90.7486 29.8126 92.3302 30.5876 92.8279 32.043C94.5082 36.9619 95.3613 42.1159 95.3613 47.3614C95.3611 73.4767 74.1154 94.7225 47.9999 94.7225Z",
    fill: "#FF1C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0004 63.4295C47.2937 63.4295 46.6103 63.161 46.0931 62.6735L23.8054 41.7369C22.6838 40.6836 22.6286 38.9205 23.6822 37.7989C24.7357 36.6787 26.4986 36.6206 27.6202 37.6771L47.7641 56.5998L84.3672 13.1475C85.3569 11.9707 87.1154 11.8199 88.2922 12.8122C89.469 13.8033 89.6198 15.5604 88.6275 16.7372L50.1305 62.4386C49.6386 63.0233 48.9261 63.3803 48.1628 63.4254C48.1093 63.4281 48.0541 63.4295 48.0004 63.4295Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRounded);
export default __webpack_public_path__ + "static/media/check-rounded.d04301b014da96650bedbce704f7988b.svg";
export { ForwardRef as ReactComponent };